// caiEmit posts a `cai:event` envelope to window.parent. targetOrigin is '*' in
// v1 because the cai_origin allowlist is explicitly deferred (see spec
// "Items 6/7 deferred"). Hardening this to a vetted allowlist is a follow-up.
export function caiEmit(name: string, payload: unknown): void {
  if (typeof window === 'undefined') return
  if (window.parent === window) return
  window.parent.postMessage({ type: 'cai:event', name, payload }, '*')
}
